export default {
      id: "icon-refresh-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-refresh",
      toString: function () {
        return this.url;
      }
    }